import { CircularProgress, Modal } from "@mui/material";
import "./style.scss";
import { AiFillQuestionCircle } from "react-icons/ai";

const ConfirmDialog = (props) => {
  const { modalText, bodyText, onClose, title, isDisabled, grayDisabled } = props || {};
  const diableAction = (props.isLoading && props.isLoading) || isDisabled || (props?.isRejectingShift && props?.payExceptionNote?.trim().length <= 0)
  return (
    <Modal
      open={props.isOpen}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="modal modal_dialog" style={{ height: "auto" }}>
        <div className="modal__header" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <h2 className="modal__title" style={{ flex: 1 }}>{title || ""}</h2>
        </div>
        <div
          className={`modal__body ${!["PAY_WITH_EXCEPTION", "CANCEL__SHIFT"].includes(modalText)
            ? "pt-5"
            : ""
            }`}
        >
          {modalText === "PAY" && <AiFillQuestionCircle className="icon" />}
          {bodyText}
        </div>
        <div className="modal__footer">
          <button className="btn" onClick={onClose} disabled={props?.isLoading}>
            {modalText && modalText === "PAY_WITH_EXCEPTION" ? "Cancel" : "No"}
          </button>
          <button
            className={`btn ${props.isRejectingShift || modalText !== "PAY_WITH_EXCEPTION"
              ? modalText === "PAY"
                ? "btn_accent"
                : "btn_reject"
              : "btn_accent"
              }`}
            style={{
              ...((grayDisabled && diableAction) &&
                { backgroundColor: '#d1cfcf', color: '#292828', borderColor: '#292828' })
            }}
            onClick={props.confirmAction}
            disabled={diableAction}
          >
            {modalText && modalText === "PAY_WITH_EXCEPTION"
              ? props.isRejectingShift
                ? "Reject"
                : "Pay"
              : "Yes"}{" "}
            {props?.isLoading && <CircularProgress className="btn__progress" />}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
